export default __webpack_public_path__ + "static/media/Bot_in_Construction_Site.5145813c.jpg";